import { PluginRegistry } from "./core/pluginRegistry";
import "./plugins";
import { UIObserverPlugin } from "./plugins/uiObserver";
import { HydraUtils } from "./utils/pluginUtils";

declare global {
  interface Window {
    HydraPluginRegistry: typeof PluginRegistry;
    HydraUtils: typeof HydraUtils;
    initHydra: () => void;
  }
}

export { HydraUtils, PluginRegistry };

function initHydra() {
  window.HydraPluginRegistry = PluginRegistry;
  window.HydraUtils = HydraUtils;

  const uiObserver = new UIObserverPlugin(document.body);
  uiObserver.init();

  setTimeout(() => {
    PluginRegistry.initAll();
  }, 0);
}

window.initHydra = initHydra;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHydra);
} else {
  initHydra();
}
